export const LOGIN_NAME = '五源'
export const COPY_RIGHT = 'Copyright 江苏五源新能源科技有限公司'
export const LOGO_SRC = '@/assets/images/logo.png'
export const WEBSITE_URL = 'https://data.wy.tou.mobi/'



// WEBPACK FOOTER //
// ./src/constant/module/configuration.js